// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"332":"012c24a2","348":"64657862","838":"95f3925d"}[chunkId] + ".js";
};